<template>
  <div class="row">
    <div class="col-12 mb-15">
      <h4 class="text-center" style="color: #f58818">
        解約金、保單價值準備金維護
      </h4>
      <form class="form">
        <div class="panel panel-form searchArea">
          <!-- 上傳檔案 -->
          <div class="form-group row">
            <label class="col-2 text-right">上傳檔案</label>
            <div class="col-10 d-inline-grid">
              <!-- 保障公式-1 -->
              <div class="ml-15 mb-15">
                <input
                  type="file"
                  id="actual-btn"
                  accept=".csv, .txt"
                  @change="fileChange"
                  hidden
                />
                <label for="actual-btn" class="btn btn-default btn-sm">
                  選擇檔案
                </label>
                <span class="lh-40">{{ fileValue }}</span>
              </div>
            </div>
          </div>

          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="doImport">
              開始匯入
            </button>
            <button
              type="button"
              class="btn btn-default"
              @click="$router.go(-1)"
            >
              返回
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12">
      <div class="mb-15 mt-40" v-if="this.importResult == '成功'">
        <span class="text-red">{{
          `上傳記錄：這個商品【${productData.insuranceName}】的【${
            this.formKind
          }型】已由【${this.$store.state.userInfo.name}】於【${moment(
            new Date()
          ).format("YYYY/MM/DD HH:mm:ss")}】上傳${
            this.importResult
          }，匯入共計【${this.importCount}】筆資料；`
        }}</span>
      </div>
      <div class="mb-15" v-if="this.form501Data.length">
        <span>匯入成功前10筆資料：</span>
      </div>
      <table class="table datatable mb-15" v-if="this.form501Data.length">
        <thead>
          <tr>
            <th width="5" class="text-center">NO</th>
            <th width="70" class="text-center">險別</th>
            <th width="70" class="text-center">投保年齡</th>
            <th width="10" class="text-center">性別</th>
            <th width="70" class="text-center">繳費年期</th>
            <th width="70" class="text-center">經過年度</th>
            <th width="50" class="text-center">繳別類型</th>
            <th width="50" class="text-center">資料別</th>
            <th width="70" class="text-center">期初金額</th>
            <th width="70" class="text-center">期末金額</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in this.form501Data.slice(0, 10)"
            :key="`form501-data-${i}`"
          >
            <td>0</td>
            <td class="text-center">{{ item.insurance_code }}</td>
            <td class="text-center">{{ item.insure_age }}</td>
            <td class="text-center">{{ item.sex }}</td>
            <td class="text-center">{{ item.payment_period }}</td>
            <td class="text-center">{{ item.year }}</td>
            <td class="text-center">{{ item.payment_kind }}</td>
            <td class="text-center">{{ item.data_kind }}</td>
            <td class="text-right">{{ item.start_amount.toFixed(4) }}</td>
            <td class="text-right">{{ item.end_amount.toFixed(4) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="mb-15" v-if="this.form501Data.length">
        <span>格式錯誤前10筆資料：</span>
      </div>
      <table class="table datatable" v-if="this.importResult">
        <thead>
          <tr>
            <th width="5" class="text-center">NO</th>
            <th width="100" class="text-center">原始字串</th>
            <th width="100" class="text-center">訊息</th>
          </tr>
        </thead>
        <tbody v-if="this.uploadFileErr.length">
          <tr
            v-for="(item, i) in this.uploadFileErr.slice(0, 10)"
            :key="`form501Err-data-${i}`"
          >
            <td class="text-center">{{ item.no }}</td>
            <td class="text-center">{{ item.raw.toString() }}</td>
            <td class="text-center">{{ item.message }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="3">
              <h4 class="mb-3">【無資料】</h4>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <mv-mask :open="mvMaskOpen" :content="mvMaskContent" />
  </div>
</template>

<script>
import {
  batchInsertForm501,
  getForm501Data,
  deleteForm501Data,
} from "@/service";
import { commonMixin } from "@/mixins/common";
import MvMask from "@/desktop/views/mv/components/mvMask";
export default {
  mixins: [commonMixin],
  name: "TerminationFeeAndReserveMaintain",
  data() {
    return {
      formKind: "Form501",
      productData: "",
      productId: "",
      fileValue: "未選擇任何檔案",
      uploadFile: "",
      uploadFileErr: [],
      rawArray: [],
      form501Data: [],
      importResult: "",
      importCount: "",
      mvMaskContent: "",
      mvMaskOpen: false,
    };
  },
  components: {
    MvMask,
  },
  methods: {
    init() {
      this.getForm501Data();
    },
    fileChange(e) {
      // 可接受的附檔名
      var validExts = new Array(".csv");

      var fileExt = e.target.value;
      fileExt = fileExt.substring(fileExt.lastIndexOf("."));
      if (validExts.indexOf(fileExt.toLowerCase()) < 0) {
        this.$toast.info({ title: "檔案格式不支援" });
        return false;
      } else {
        this.fileValue = e.target.files[0].name;
        this.uploadFile = e.target.files[0];
      }
    },
    // 檔案匯入
    async doImport() {
      if (!this.uploadFile) {
        this.$toast.info({ title: "未選擇任何檔案匯入" });
        return;
      } else {
        this.mvMaskContent = "檔案匯入中，請稍候...";
        this.panelOpen("mvMaskOpen");
        //讀取CSV並轉換成array
        const res = await this.readCSV(this.uploadFile);
        this.rawArray = res.split("\r\n");
        this.rawArray.forEach((item, index) => {
          if (!item.trim()) {
            return;
          }
          if ((item.match(/,/g) || []).length != 10) {
            this.uploadFileErr.push({
              no: index + 1,
              raw: this.rawArray[index],
              message: `CSR ${this.formKind}型-欄位需為11欄位`,
            });
          }
        });
        let datas = this.rawArray.map((x) => {
          const {
            0: INSURANCE_CODE,
            1: INSURE_AGE,
            2: SEX,
            3: PAYMENT_PERIOD,
            4: TYPE1,
            5: TYPE2,
            6: YEAR,
            7: PAYMENT_KIND,
            8: DATA_KIND,
            9: START_AMOUNT,
            10: END_AMOUNT,
          } = x.split(",");
          return {
            INSURANCE_CODE,
            INSURE_AGE,
            SEX,
            PAYMENT_PERIOD,
            TYPE1,
            TYPE2,
            YEAR,
            PAYMENT_KIND,
            DATA_KIND,
            START_AMOUNT,
            END_AMOUNT,
          };
        });
        //若最後一行有換行符號，則下一行會被程式誤判為一筆資料
        if (
          !datas[datas.length - 1].INSURANCE_CODE &&
          !datas[datas.length - 1].INSURE_AGE &&
          !datas[datas.length - 1].SEX &&
          !datas[datas.length - 1].PAYMENT_PERIOD &&
          !datas[datas.length - 1].TYPE1 &&
          !datas[datas.length - 1].TYPE2 &&
          !datas[datas.length - 1].YEAR &&
          !datas[datas.length - 1].PAYMENT_KIND &&
          !datas[datas.length - 1].DATA_KIND &&
          !datas[datas.length - 1].START_AMOUNT &&
          !datas[datas.length - 1].END_AMOUNT
        ) {
          datas.pop();
        }

        //檢核資料格式
        datas = this.validateDatas(datas);

        //發送API請求內容
        const req = {
          PRODUCTID: this.productId,
        };
        //分批發送API
        const groupData = this.group(datas, 2000); //每組資料2千筆
        let count = 0;
        let failCount = 0;
        let failMessage = "";
        this.asyncForEach(groupData, async (item, index) => {
          if (index === 0) {
            await deleteForm501Data(req).then((result) => {
              if (!(result.header && result.header.status == "200")) {
                failMessage += result.header.message;
                failCount += 1;
              }
            });
          }
          req.batchList = item;
          await batchInsertForm501(req).then((result) => {
            count += 1;
            if (!(result.header && result.header.status == "200")) {
              failCount += 1;
              failMessage += result.header.message;
            }
            if (count == groupData.length) {
              if (failCount > 0) {
                this.$toast.info({ title: failMessage });
                this.importCount = 0;
                this.importResult = "失敗";
              } else {
                this.getForm501Data();
                this.importCount = datas.length;
                this.importResult = "成功";
              }
              this.panelClose("mvMaskOpen");
            }
          });
        });
      }
    },
    readCSV(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = (event) => {
          resolve(event.target.result);
        };
      });
    },
    //非同步ForEach
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index);
      }
    },
    //依輸入筆數進行資料分群
    group(array, subGroupLength) {
      let index = 0;
      const newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },
    //檢核檔案
    validateDatas(datas) {
      const regexSex = /^[1|2]?$/;
      const regexNumber = /^[0-9]+$/;
      const regexDecimal = /^[-+]?[0-9]+[.]?[0-9]*$/;
      datas.forEach((item, index) => {
        if (
          this.uploadFileErr.map((item) => item["no"]).indexOf(index + 1) != -1
        ) {
          return;
        }
        if (
          item.INSURE_AGE == "" ||
          (item.INSURE_AGE != "" && !regexNumber.test(item.INSURE_AGE))
        ) {
          this.uploadFileErr.push({
            no: index + 1,
            raw: this.rawArray[index],
            message: "投保年齡不可空白或格式不正確",
          });
        }
        if (
          item.YEAR == "" ||
          (item.YEAR != "" && !regexNumber.test(item.YEAR))
        ) {
          this.uploadFileErr.push({
            no: index + 1,
            raw: this.rawArray[index],
            message: "經過年度不可空白或格式不正確",
          });
        }
        if (item.SEX == "" || (item.SEX != "" && !regexSex.test(item.SEX))) {
          this.uploadFileErr.push({
            no: index + 1,
            raw: this.rawArray[index],
            message: "性別不可空白或格式不正確",
          });
        }
        if (
          item.PAYMENT_KIND == "" ||
          (item.PAYMENT_KIND != "" && !regexNumber.test(item.PAYMENT_KIND))
        ) {
          this.uploadFileErr.push({
            no: index + 1,
            raw: this.rawArray[index],
            message: "繳別類型不可空白或格式不正確",
          });
        }
        if (
          item.DATA_KIND == "" ||
          (item.DATA_KIND != "" && !regexNumber.test(item.DATA_KIND))
        ) {
          this.uploadFileErr.push({
            no: index + 1,
            raw: this.rawArray[index],
            message: "資料別不可空白或格式不正確",
          });
        }
        if (
          item.START_AMOUNT == "" ||
          (item.START_AMOUNT != "" && !regexDecimal.test(item.START_AMOUNT))
        ) {
          this.uploadFileErr.push({
            no: index + 1,
            raw: this.rawArray[index],
            message: "期初金額不可空白或格式不正確",
          });
        }
        if (
          item.END_AMOUNT == "" ||
          (item.END_AMOUNT != "" && !regexDecimal.test(item.END_AMOUNT))
        ) {
          this.uploadFileErr.push({
            no: index + 1,
            raw: this.rawArray[index],
            message: "期末金額不可空白或格式不正確",
          });
        }
      });

      if (this.uploadFileErr.length > 0) {
        datas = datas.filter(
          (element, index) =>
            this.uploadFileErr.map((item) => item["no"]).indexOf(index + 1) ==
            -1
        );
      }

      return datas;
    },
    //查詢列表資料
    getForm501Data() {
      const req = {
        PRODUCTID: this.productId,
      };
      getForm501Data(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.form501Data = result.data;
        } else {
          this.form501Data = [];
          this.$toast.info({ title: result.header.message });
        }
      });
    },
  },
  mounted() {
    this.productData = JSON.parse(localStorage.productData);
    this.productId = this.productData.productId;
    this.init();
  },
};
</script>
<style scoped>
.lh-40 {
  line-height: 40px;
}
.mb-15 {
  margin-bottom: 15px;
}
.searchArea {
  border-color: #f3a759;
  border-width: 3px;
  background-color: white;
}
.d-inline-grid {
  display: inline-grid;
}
</style>
